import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React, { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { ChevronUp, ChevronDown } from '@indeed/ifl-icons';
import { InputWrapper } from '../Input/InputWrapper.js';
import { jsx } from '@emotion/react';
import { baseStyles, inputStyles } from '../Input/Input.js';
import { Button } from '../Button/Button.js';
import { Flex } from '../Flex/Flex.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../TouchTarget/TouchTarget.js';
import '../Text/Text.js';
import '../../utils/createResponsive.js';
import '../../constants/index.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../../utils/warn.js';
import '../../hooks/useCheckValidity.js';
import '../Input/ChipInput.js';
import '../Input/styles.js';
import '../Input/AutosizeInput.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Chip/ChipGroup.js';
import '../Chip/Chip.js';
import '@emotion/is-prop-valid';
import '@indeed/ihl-use-id';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../Label/Label.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/displayName.js';
import '../Box/Box.js';

const StyledSuggestListInput = /*#__PURE__*/themed("input", process.env.NODE_ENV === "production" ? {
  styleProps: ["contentBefore", "contentAfter", "size"],
  shouldForwardProp: prop => prop !== "contentBefore" && prop !== "contentAfter" && prop !== "size",
  target: "ehiczq0"
} : {
  styleProps: ["contentBefore", "contentAfter", "size"],
  shouldForwardProp: prop => prop !== "contentBefore" && prop !== "contentAfter" && prop !== "size",
  target: "ehiczq0",
  label: "StyledSuggestListInput"
})(baseStyles, inputStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const SuggestListInput = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    contentAfter,
    contentBefore,
    disabled = false,
    invalid = false,
    canOpen,
    isOpen,
    size = "md",
    setPopupAnchor,
    toggleButtonProps = {
      "aria-label": "Show suggestions"
    },
    toggleButtonRef,
    openPopup,
    closePopup,
    hideToggleButton = false,
    messageId,
    ...remainingProps
  } = props;
  const ariaDescribedBy = [remainingProps["aria-describedby"], messageId].filter(value => value !== undefined).filter(Boolean).join(" ") || undefined;
  return jsx(InputWrapper, {
    ref: setPopupAnchor,
    size: size,
    disabled: disabled,
    invalid: invalid,
    contentBefore: contentBefore,
    contentAfter:
    // Need to conditionally render this fragment only if either contentAfter
    // is provided or hideToggleButton is false, otherwise we get an empty span
    // that still takes up this space even when there is nothing there.
    contentAfter || !hideToggleButton ? jsx(React.Fragment, null, contentAfter && jsx(Flex, {
      sx: {
        marginInlineEnd: hideToggleButton ? 0 : 1
      }
    }, contentAfter), !hideToggleButton && jsx(Button, _extends({
      iconOnly: true,
      ref: toggleButtonRef,
      "aria-controls": props["aria-controls"],
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": props["aria-expanded"],
      "aria-hidden": false,
      "aria-haspopup": "listbox",
      type: "button",
      size: "sm",
      variant: "tertiary",
      sx: {
        minInlineSize: "unset",
        minBlockSize: "unset",
        paddingBlockStart: 0,
        paddingBlockEnd: 0,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        /**
         * Ensure minimum touch target size.
         *
         * `Button` does not leverage `TouchTarget`. Instead, it uses
         * `calc` to add an additional `10px` to the parent's height.
         * Removing the `padding` above results in the size of the
         * `::before` element falling below `44px`.
         */
        "::before": {
          minInlineSize: 44,
          minBlockSize: 44
        }
      },
      tabIndex: -1,
      onClick: () => {
        if (isOpen) {
          closePopup();
        } else if (canOpen) {
          openPopup();
        }
      }
    }, toggleButtonProps), isOpen && canOpen ? jsx(ChevronUp, {
      "aria-hidden": true
    }) : jsx(ChevronDown, {
      "aria-hidden": true
    }))) : null
  }, jsx(StyledSuggestListInput, _extends({
    ref: forwardedRef
    // FIXME: fix this type error
    // @ts-ignore
    ,
    size: size,
    contentBefore: contentBefore,
    contentAfter: contentAfter,
    disabled: disabled
  }, remainingProps, {
    defaultValue: undefined,
    "aria-describedby": ariaDescribedBy
  })));
});

export { SuggestListInput };
